/* Rescuevation · HALO 100K Premium (rescu-hlo-*), 15.10.2026

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Dieses Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse hlo-go, nach animationend
   wieder entfernt) und startet Schleifen nur, solange sie zu sehen sind.

   Kaufen: /cart/add.js, danach die Warenkorb-Schublade. Die Section-Liste kommt
   von der Schublade selbst (getSectionsToRender), weil die Live-Schublade b4c
   andere Sections rendert als Dawns Standard. */
(function () {
  'use strict';
  if (window.__rhlo) return;
  window.__rhlo = true;

  var doc = document.documentElement;
  doc.classList.add('hlo-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var feinZeiger = window.matchMedia('(pointer: fine)').matches;
  var zahlFmt = new Intl.NumberFormat('de-DE');
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var imBild = function (el) { var r = el.getBoundingClientRect(); return r.top < vh() - 40 && r.bottom > 0; };

  /* ---------- Einmalige Läufe ---------- */

  function einmal(el, klasse, dauer) {
    klasse = klasse || 'hlo-go';
    var schluessel = '__hlo_' + klasse;
    if (el[schluessel]) return;
    el[schluessel] = true;
    el.classList.add(klasse);
    var fertig = false;
    var ende = function (e) {
      if (fertig) return;
      if (e && e.target !== el) return;
      fertig = true;
      el.classList.remove(klasse);
      el.removeEventListener('animationend', ende);
    };
    el.addEventListener('animationend', ende);
    setTimeout(function () { ende(); }, dauer || 2600);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      el.style.setProperty('--hlo-d', Math.min(n * 90, 540) + 'ms');
      gruppen.set(g, n + 1);
    });
  }

  function einblenden() {
    if (ruhig || !hatIO) return;
    var els = alle(document, '.hlo [data-hlo-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.hasAttribute('data-hlo-sofort')) { einmal(el); return; }
      if (imBild(el)) return;
      io.observe(el);
    });

    var linien = alle(document, '.hlo [data-hlo-linie]');
    var io2 = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io2.unobserve(e.target);
        einmal(e.target, 'hlo-linie-go', 2000);
      });
    }, { rootMargin: '0px 0px -15% 0px' });
    linien.forEach(function (el) { if (!imBild(el)) io2.observe(el); });
  }

  /* ---------- Schleifen nur, solange sichtbar ---------- */

  function schleifen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { e.target.classList.toggle('hlo-spielt', e.isIntersecting); });
    }, { threshold: 0.1 });
    alle(document, '.hlo [data-hlo-spiel]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehle(el, verzoegerung) {
    var ziel = parseInt(String(el.getAttribute('data-hlo-zahl')).replace(/\D/g, ''), 10);
    if (!ziel || ziel <= 0) return;
    var endText = el.textContent;
    var t0 = null;
    var dauer = ziel >= 1000 ? 1800 : 1300;
    var schritt = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dauer);
      var w = 1 - Math.pow(1 - p, 4);
      el.textContent = zahlFmt.format(Math.round(ziel * w));
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
    };
    setTimeout(function () { el.textContent = '0'; requestAnimationFrame(schritt); }, verzoegerung || 0);
  }

  function zaehlen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        zaehle(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    alle(document, '.hlo [data-hlo-zahl]').forEach(function (el) {
      if (el.hasAttribute('data-hlo-zahl-sofort')) return;
      io.observe(el);
    });
  }

  /* ---------- Bühne: Zünden und Lichtkegel am Zeiger ---------- */

  function buehne() {
    alle(document, '[data-hlo-zuender]').forEach(function (fig) {
      var zahl = fig.querySelector('[data-hlo-zahl-sofort]');
      if (ruhig) return;
      einmal(fig, 'hlo-zuendet', 2800);
      if (zahl) zaehle(zahl, 820);
    });
    if (ruhig || !feinZeiger) return;
    alle(document, '[data-hlo-spot]').forEach(function (sec) {
      var plan = null;
      sec.addEventListener('pointermove', function (e) {
        if (plan) return;
        plan = requestAnimationFrame(function () {
          plan = null;
          var r = sec.getBoundingClientRect();
          sec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          sec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
    });
  }

  /* ---------- Galerie ---------- */

  function galerie() {
    alle(document, '[data-hlo-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-hlo-band]');
      var minis = alle(g, '[data-hlo-mini]');
      if (!band) return;
      var bilder = alle(band, '.hlo-galerie__bild');
      var aktuell = 0;
      var gehe = function (i) {
        i = Math.max(0, Math.min(bilder.length - 1, i));
        band.scrollTo({ left: bilder[i].offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
      };
      var markieren = function () {
        var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
        if (i === aktuell) return;
        aktuell = i;
        minis.forEach(function (m, n) { m.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        var zaehler = g.querySelector('[data-hlo-zaehler]');
        if (zaehler) zaehler.textContent = String(i + 1);
        var m = minis[i];
        if (m && m.parentElement) {
          var reihe = m.parentElement;
          var links = m.offsetLeft - reihe.clientWidth / 2 + m.clientWidth / 2;
          reihe.scrollTo({ left: links, behavior: ruhig ? 'auto' : 'smooth' });
        }
      };
      band.addEventListener('scroll', function () { window.requestAnimationFrame(markieren); }, { passive: true });
      minis.forEach(function (m, i) { m.addEventListener('click', function () { gehe(i); }); });
      var vor = g.querySelector('[data-hlo-vor]');
      var zurueck = g.querySelector('[data-hlo-zurueck]');
      if (vor) vor.addEventListener('click', function () { gehe(aktuell + 1 >= bilder.length ? 0 : aktuell + 1); });
      if (zurueck) zurueck.addEventListener('click', function () { gehe(aktuell - 1 < 0 ? bilder.length - 1 : aktuell - 1); });
      band.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gehe(aktuell + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(aktuell - 1); }
      });
    });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) {
          var fehler = new Error(daten.description || daten.message || 'HTTP ' + res.status);
          fehler.hinzu = false;
          throw fehler;
        }
        return daten;
      });
    }).then(function (daten) {
      try {
        if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(daten);
        } else {
          window.location.href = root + 'cart';
        }
      } catch (e) {
        /* Artikel liegt schon im Korb: nicht noch einmal senden, sondern zur Warenkorbseite */
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  var HAKEN = '<svg class="hlo-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg>';

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__hloLabel) btn.__hloLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Wird hinzugefügt …</span>';
    } else {
      btn.disabled = false;
      if (btn.__hloLabel) btn.innerHTML = btn.__hloLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__hloLabel || btn.innerHTML;
    btn.disabled = false;
    btn.classList.add('ist-ok');
    btn.innerHTML = HAKEN + '<span>Im Warenkorb</span>';
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
  }

  function stepper() {
    alle(document, '[data-hlo-stepper]').forEach(function (st) {
      var feld = st.querySelector('input');
      var setzen = function (n) {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '99', 10);
        feld.value = Math.max(min, Math.min(max, n || min));
      };
      st.querySelector('[data-hlo-minus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) - 1); });
      st.querySelector('[data-hlo-plus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) + 1); });
      feld.addEventListener('change', function () { setzen(parseInt(feld.value, 10)); });
    });
  }

  function kauf() {
    alle(document, '[data-hlo-form]').forEach(function (form) {
      var btn = form.querySelector('[data-hlo-submit]');
      var fehler = form.querySelector('[data-hlo-fehler]');
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var id = parseInt(form.querySelector('[data-hlo-variante]').value, 10);
        var n = Math.max(1, parseInt((form.querySelector('[data-hlo-anzahl]') || {}).value, 10) || 1);
        if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
        knopfLaeuft(btn, true);
        inDenWarenkorb([{ id: id, quantity: n }]).then(function () {
          knopfOk(btn);
        }).catch(function (err) {
          knopfLaeuft(btn, false);
          if (fehler) {
            fehler.hidden = false;
            fehler.textContent = (err && err.message) ? err.message : 'Das hat nicht geklappt. Bitte versuch es noch einmal oder ruf uns an.';
          }
        });
      });
    });
  }

  /* ---------- Lichtregie ---------- */

  function regie() {
    alle(document, '[data-hlo-regie]').forEach(function (sec) {
      var lmEl = sec.querySelector('[data-hlo-lm]');
      var winkelEl = sec.querySelector('[data-hlo-winkel]');
      var panelsEl = sec.querySelector('[data-hlo-panels]');
      var neigEl = sec.querySelector('[data-hlo-neigung]');
      var segKnoepfe = alle(sec, '[data-hlo-seg]');
      var neigKnoepfe = alle(sec, '[data-hlo-neig]');
      var dimmer = alle(sec, '[data-hlo-dimmer]');
      var zustand = { seg: 360, k1: 100, k2: 100, neig: 0 };
      var lmJetzt = 100000;
      var lmPlan = null;

      function lmZeigen(ziel) {
        if (!lmEl) return;
        if (ruhig) { lmJetzt = ziel; lmEl.textContent = zahlFmt.format(ziel); return; }
        var von = lmJetzt, t0 = null;
        if (lmPlan) cancelAnimationFrame(lmPlan);
        var lauf = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 420);
          var w = 1 - Math.pow(1 - p, 3);
          lmJetzt = Math.round(von + (ziel - von) * w);
          lmEl.textContent = zahlFmt.format(Math.round(lmJetzt / 100) * 100);
          if (p < 1) lmPlan = requestAnimationFrame(lauf); else { lmJetzt = ziel; lmEl.textContent = zahlFmt.format(ziel); }
        };
        lmPlan = requestAnimationFrame(lauf);
      }

      function zeichnen() {
        var p1 = zustand.k1 / 100;
        var p2 = zustand.k2 / 100;
        var an2 = zustand.seg === 360;
        var neigFaktor = 1 - (zustand.neig / 45) * 0.22;
        sec.style.setProperty('--s1', (Math.sqrt(p1) * neigFaktor).toFixed(3));
        sec.style.setProperty('--o1', (0.35 + 0.65 * p1).toFixed(3));
        sec.style.setProperty('--z1', (0.3 + 0.7 * p1).toFixed(3));
        sec.style.setProperty('--s2', an2 ? (Math.sqrt(p2) * neigFaktor).toFixed(3) : '0.2');
        sec.style.setProperty('--o2', an2 ? (0.35 + 0.65 * p2).toFixed(3) : '0');
        sec.style.setProperty('--z2', an2 ? (0.3 + 0.7 * p2).toFixed(3) : '1');
        sec.style.setProperty('--neig', String(zustand.neig));
        sec.classList.toggle('ist-180', !an2);

        dimmer.forEach(function (d) {
          var k = d.getAttribute('data-hlo-dimmer');
          var v = k === '1' ? zustand.k1 : zustand.k2;
          var knopf = d.closest('.hlo-knopf');
          if (knopf) {
            knopf.style.setProperty('--p', ((v - 10) / 90).toFixed(3));
            knopf.classList.toggle('ist-aus', k === '2' && !an2);
          }
          d.disabled = k === '2' && !an2;
          d.setAttribute('aria-valuetext', v + ' Prozent');
          var out = sec.querySelector('[data-hlo-prozent="' + k + '"]');
          if (out) out.textContent = (k === '2' && !an2) ? 'aus' : v + ' %';
        });

        var lm = Math.round(50000 * p1 + (an2 ? 50000 * p2 : 0));
        lmZeigen(lm);
        if (winkelEl) winkelEl.textContent = an2 ? '360° rundum' : '180° gezielt';
        if (panelsEl) panelsEl.textContent = an2 ? '24 Panels' : '12 Panels';
        if (neigEl) neigEl.textContent = 'Neigung ' + zustand.neig + '°';
        segKnoepfe.forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-hlo-seg'), 10) === zustand.seg)); });
        neigKnoepfe.forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-hlo-neig'), 10) === zustand.neig)); });
      }

      segKnoepfe.forEach(function (b) {
        b.addEventListener('click', function () { zustand.seg = parseInt(b.getAttribute('data-hlo-seg'), 10); zeichnen(); });
      });
      neigKnoepfe.forEach(function (b) {
        b.addEventListener('click', function () { zustand.neig = parseInt(b.getAttribute('data-hlo-neig'), 10); zeichnen(); });
      });
      dimmer.forEach(function (d) {
        d.addEventListener('input', function () {
          var v = parseInt(d.value, 10);
          if (d.getAttribute('data-hlo-dimmer') === '1') zustand.k1 = v; else zustand.k2 = v;
          zeichnen();
        });
        /* Drehen am Regler: Winkel zur Mitte, −135° bis +135° auf 10 bis 100 % */
        var knopf = d.closest('.hlo-knopf');
        var rad = knopf && knopf.querySelector('[data-hlo-rad]');
        if (!rad) return;
        var dreht = false;
        var ausWinkel = function (e) {
          var r = rad.getBoundingClientRect();
          var w = Math.atan2(e.clientX - (r.left + r.width / 2), -(e.clientY - (r.top + r.height / 2))) * 180 / Math.PI;
          w = Math.max(-135, Math.min(135, w));
          var v = Math.round((10 + (w + 135) / 270 * 90) / 5) * 5;
          if (String(v) !== d.value) {
            d.value = v;
            d.dispatchEvent(new Event('input', { bubbles: true }));
          }
        };
        rad.addEventListener('pointerdown', function (e) {
          if (d.disabled) return;
          dreht = true;
          rad.setPointerCapture(e.pointerId);
          ausWinkel(e);
        });
        rad.addEventListener('pointermove', function (e) { if (dreht) ausWinkel(e); });
        var los = function () { dreht = false; };
        rad.addEventListener('pointerup', los);
        rad.addEventListener('pointercancel', los);
      });

      zeichnen();

      if (!ruhig && hatIO) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          einmal(sec, 'hlo-zuend', 2600);
        }, { threshold: 0.3 });
        io.observe(sec.querySelector('.hlo-regie__buehne') || sec);
      }
    });
  }

  /* ---------- Einsatznacht ---------- */

  function nacht() {
    alle(document, '[data-hlo-nacht]').forEach(function (sec) {
      var buehne = sec.querySelector('[data-hlo-buehne]');
      var phasen = alle(sec, '[data-hlo-phase]');
      if (!buehne || !phasen.length || !hatIO) return;
      var lmEl = buehne.querySelector('[data-hlo-n-lm]');
      var modusEl = buehne.querySelector('[data-hlo-n-modus]');
      var zeitEl = buehne.querySelector('[data-hlo-n-zeit]');
      sec.classList.add('hlo-nacht--live');
      function aktiv(ph) {
        phasen.forEach(function (p) { p.classList.toggle('ist-aktiv', p === ph); });
        buehne.setAttribute('data-szene', ph.getAttribute('data-szene'));
        if (lmEl) lmEl.textContent = ph.getAttribute('data-lm') || '';
        if (modusEl) modusEl.textContent = ph.getAttribute('data-modus') || '';
        if (zeitEl) zeitEl.textContent = ph.getAttribute('data-zeit') || '';
      }
      var mobil = window.matchMedia('(max-width: 989px)').matches;
      var io = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { if (e.isIntersecting) aktiv(e.target); });
      }, { rootMargin: mobil ? '-62% 0px -30% 0px' : '-45% 0px -45% 0px' });
      phasen.forEach(function (p) { io.observe(p); });
      aktiv(phasen[0]);
    });
  }

  /* ---------- Rechner ---------- */

  function rechner() {
    alle(document, '[data-hlo-rechner]').forEach(function (sec) {
      var lebensdauer = parseFloat(sec.getAttribute('data-lebensdauer')) || 70000;
      var watt = parseFloat(sec.getAttribute('data-watt')) || 660;
      var h = sec.querySelector('[data-hlo-r="h"]');
      var n = sec.querySelector('[data-hlo-r="n"]');
      var vorlagen = alle(sec, '[data-hlo-vorlage]');
      var setze = function (sel, text) { var el = sec.querySelector(sel); if (el) el.textContent = text; };
      function rechne() {
        var hv = parseInt(h.value, 10), nv = parseInt(n.value, 10);
        var hJahr = hv * nv;
        var jahre = lebensdauer / hJahr;
        var zehn = Math.min(100, Math.round(hJahr * 10 / lebensdauer * 100));
        setze('[data-hlo-r-out="h"]', hv + ' h');
        setze('[data-hlo-r-out="n"]', String(nv));
        setze('[data-hlo-r-jahre]', zahlFmt.format(jahre >= 10 ? Math.round(jahre) : Math.round(jahre * 10) / 10));
        setze('[data-hlo-r-hjahr]', zahlFmt.format(hJahr));
        setze('[data-hlo-r-zehn]', String(zehn));
        setze('[data-hlo-r-kwh]', (Math.round(hv * watt / 100) / 10).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));
        var balken = sec.querySelector('[data-hlo-r-balken]');
        if (balken) balken.style.setProperty('--anteil', (Math.max(1, zehn) / 100).toFixed(3));
        vorlagen.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hlo-vorlage') === hv + ',' + nv)); });
      }
      [h, n].forEach(function (el) { el.addEventListener('input', rechne); });
      vorlagen.forEach(function (b) {
        b.addEventListener('click', function () {
          var w = b.getAttribute('data-hlo-vorlage').split(',');
          h.value = w[0]; n.value = w[1];
          rechne();
        });
      });
      rechne();
    });
  }

  /* ---------- Anfrage vorbefüllen ---------- */

  function formular() { return document.querySelector('[data-hlo-formular]'); }

  function anliegenSetzen(wert) {
    var f = formular();
    if (!f || !wert) return;
    var sel = f.querySelector('[data-hlo-f-anliegen]');
    if (!sel) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === wert) { sel.selectedIndex = i; break; }
    }
  }

  function anliegen() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-hlo-anliegen]');
      if (!a) return;
      anliegenSetzen(a.getAttribute('data-hlo-anliegen'));
    });
  }

  function system() {
    alle(document, '[data-hlo-system]').forEach(function (sec) {
      var haken = alle(sec, '[data-hlo-teil]');
      var satz = sec.querySelector('[data-hlo-set]');
      var knopf = sec.querySelector('[data-hlo-set-anfrage]');
      var grund = satz ? satz.textContent : '';
      var gewaehlt = function () { return haken.filter(function (h) { return h.checked; }).map(function (h) { return h.value; }); };
      function aktualisieren() {
        var g = gewaehlt();
        if (!satz) return;
        satz.textContent = g.length ? grund.replace(/\.$/, '') + ', dazu ' + g.join(', ') + '.' : grund;
      }
      haken.forEach(function (h) { h.addEventListener('change', aktualisieren); });
      if (knopf) {
        knopf.addEventListener('click', function () {
          var f = formular();
          if (!f) return;
          anliegenSetzen('Angebot');
          var g = gewaehlt();
          var aus = f.querySelector('[data-hlo-f-ausfuehrung]');
          if (aus) {
            var mitStativ = g.some(function (x) { return /Stativ/i.test(x) && !/Tasche/i.test(x); });
            for (var i = 0; i < aus.options.length; i++) {
              var t = aus.options[i].value;
              if ((mitStativ && /Stativ/i.test(t)) || (!mitStativ && /einzeln/i.test(t))) { aus.selectedIndex = i; break; }
            }
          }
          var text = f.querySelector('[data-hlo-f-text]');
          if (text && g.length) {
            var zeile = 'Set: HALO 100K mit ' + g.join(', ') + '.';
            if (text.value.indexOf('Set:') === 0) text.value = text.value.replace(/^Set:[^\n]*/, zeile);
            else text.value = zeile + (text.value ? '\n' + text.value : '');
          }
        });
      }
    });
  }

  /* ---------- Kaufleiste ---------- */

  function leiste() {
    var st = document.querySelector('[data-hlo-sticky]');
    if (!st || !hatIO) return;
    var kaufForm = document.querySelector('[data-hlo-form]');
    var kontakt = document.getElementById('ContactForm');
    var fuss = document.querySelector('footer, .footer, #shopify-section-footer');
    var kaufSichtbar = true, kontaktSichtbar = false, fussSichtbar = false, tief = false;

    function pruefen() {
      var zeigen = tief && !kaufSichtbar && !kontaktSichtbar && !fussSichtbar;
      if (zeigen) {
        if (st.hidden) {
          st.hidden = false;
          st.classList.add('ist-weg');
          requestAnimationFrame(function () { requestAnimationFrame(function () { st.classList.remove('ist-weg'); }); });
        } else st.classList.remove('ist-weg');
      } else if (!st.hidden) {
        st.classList.add('ist-weg');
      }
    }
    if (kaufForm) new IntersectionObserver(function (e) { kaufSichtbar = e[0].isIntersecting; pruefen(); }).observe(kaufForm);
    else kaufSichtbar = false;
    if (kontakt) new IntersectionObserver(function (e) { kontaktSichtbar = e[0].isIntersecting; pruefen(); }).observe(kontakt);
    if (fuss) new IntersectionObserver(function (e) { fussSichtbar = e[0].isIntersecting; pruefen(); }).observe(fuss);
    window.addEventListener('scroll', function () {
      var t = window.scrollY > 600;
      if (t !== tief) { tief = t; pruefen(); }
    }, { passive: true });

    var knopf = st.querySelector('[data-hlo-sticky-kauf]');
    if (knopf && kaufForm && window.fetch) {
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var label = knopf.innerHTML;
        var id = parseInt(kaufForm.querySelector('[data-hlo-variante]').value, 10);
        var n = Math.max(1, parseInt((kaufForm.querySelector('[data-hlo-anzahl]') || {}).value, 10) || 1);
        knopf.classList.add('ist-ok');
        inDenWarenkorb([{ id: id, quantity: n }]).then(function () {
          knopf.innerHTML = HAKEN + (knopf.classList.contains('hlo-sticky__neben') ? '' : '<span>Im Warenkorb</span>');
          setTimeout(function () { knopf.classList.remove('ist-ok'); knopf.innerHTML = label; }, 2400);
        }).catch(function () {
          knopf.classList.remove('ist-ok');
          var ziel = document.getElementById('kaufen');
          if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
        });
      });
    }
  }

  /* ---------- Start ---------- */

  function start() {
    stepper();
    galerie();
    kauf();
    regie();
    nacht();
    rechner();
    anliegen();
    system();
    buehne();
    einblenden();
    schleifen();
    zaehlen();
    leiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
